import useReceiptFilters from "../../../hooks/useReceiptFilters.jsx";
import Button from "../button/Button.jsx";
import DateInput from "../input/DateInput.jsx";
import TextInput from "../input/TextInput";

const FormReceipts = ({ refetch }) => {
  const { filters, setFilter, resetFilters } = useReceiptFilters();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilter(name, value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const cleaned = Object.fromEntries(
      Object.entries(filters).filter(([, v]) => v !== "" && v != null),
    );
    if (cleaned.processed !== undefined) {
      cleaned.processed = cleaned.processed === "true";
    }

    await refetch(cleaned);
  };

  const handleReset = async () => {
    resetFilters();
  };

  return (
    <form
      id={"form-emcs"}
      onSubmit={handleSubmit}
      onReset={handleReset}
      className="w-full"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <TextInput id="arc" text="A.R.C. Documento:" value={filters.arc} onChange={handleChange} />
        <DateInput
          id="start_date"
          text="Fecha de Expedición Desde >"
          value={filters.start_date}
          onChange={handleChange}
        />
        <DateInput
          id="end_date"
          text="Fecha de Expedición Hasta <"
          value={filters.end_date}
          onChange={handleChange}
        />
      </div>
      <div className={"w-full py-4"}>
        <ul className={"flex justify-center space-x-4"}>
          <Button type="submit">
            Buscar
          </Button>
          <Button type="reset">
            Limpiar
          </Button>
        </ul>
      </div>
    </form>
  );
};

export default FormReceipts;
